import defaultTheme from './defaultTheme';
import constants from '../../constants';
export default {
  ...defaultTheme,

  //for fantasy header
  fantasyHeaderStartColor: '#040628',
  fantasyHeaderEndColor: '#040628',
  fantasyTeamAColor: '#ffbe0f',
  fantasyTeamBColor: '#ff3c3c',

  //For match status
  fantasyMatchDefault: constants.Colors.WildStrawberry,
  fantasyMatchComplete: constants.Colors.Lime,
  fantasyMatchLive: constants.Colors.DarkTangerine,
  fantasyMatchCancel: constants.Colors.Red,
  fantasyMatchTimerStartColor: '#040628',
  fantasyMatchTimeEndColor: '#040628',
  fantasyMatchPlayerPlaying: constants.Colors.Lime,
  fantasyMatchPlayerNotPlaying: constants.Colors.Red,

  //For fantasy home
  fantasyHomeContainer: constants.Colors.RegalBlue,
  fantasyHomeTabBackground: constants.Colors.Sapphire,
  fantasyHomeHeaderTabText: constants.Colors.WildBlueYonder,
  fantasyHomeMatchListContainer: constants.Colors.DarkBlue,
  fantasyHomeTabBarBackground: constants.Colors.Sapphire,
  fantasyHomeTabBarWrapperBG: constants.Colors.BlackRussian,
  fantasyHomeSeparatorBG: constants.Colors.DarkPurple,
  fantasyHomeActiveHeaderBorderBottom: constants.Colors.WildStrawberry,
  fantasyHomeAccountIcon: constants.Colors.White,
  fantasyHomeNotificationIcon: constants.Colors.White,
  fantasyHomeHeaderText: constants.Colors.White,
  fantasyHomeComingSoon: constants.Colors.White,
  fantasyHomeBottomTabContainer: constants.Colors.newBackground,
  fantasyHomeBottomTabWrapper: '#111939',
  fantasyHomeGoToContainer: constants.Colors.newBackground,

  //for fantasy home landing
  homeLandingContainer: constants.Colors.Sapphire,
  homeLandingTabBottomBorder: constants.Colors.DodgerBlue,
  homeLandingMatchListContainer: constants.Colors.DarkBlue,
  homeLandingTabBarBG: constants.Colors.Sapphire,
  homeLandingTabBarText: constants.Colors.DodgerBlue,
  matchListEndLiner: constants.Colors.White,

  //for my matches home
  fantasyMyMatchesHomeContainer: constants.Colors.RegalBlue,
  fantasyMyMatchesHomeContainer1: constants.Colors.Sapphire,
  fantasyMyMatchesHomeContainer2: constants.Colors.DarkBlue,

  //for my matches
  myMatchesContainer: constants.Colors.DarkBlue,
  myMatchesTabBarBG: '#06082a',
  myMatchesTabBarText: constants.Colors.PattensBlue,
  myMatchesTabBarActiveBorder: constants.Colors.DodgerBlue,
  myMatchesTabBarActiveText: constants.Colors.DodgerBlue,
  myMatchListEndText: constants.Colors.White,

  // for match card
  matchCardActiveContainer: constants.Colors.DarkBlue1,
  matchCardInActiveContainer: constants.Colors.BlueGrey,
  matchCardRippleColor: '#0a0e32',
  matchCardLeagueNameEnable: constants.Colors.White,
  matchCardTeamNameEnable: constants.Colors.White,
  matchCardLeagueNameDisable: constants.Colors.White,
  matchCardTeamNameDisable: constants.Colors.White,
  matchCardTimer: constants.Colors.White,
  matchCardContestJoinedText: constants.Colors.White,
  matchCardContestJoinedSeparator: constants.Colors.JacksonsPurple,
  matchCardLineupOut: constants.Colors.Lime,
  matchCardBonusLeagueBG: constants.Colors.JacksonsPurple,
  matchCardBonusLeagueTitle: constants.Colors.White,
  matchCardWinAmountDivider: '#242d57',
  matchCardWinAmountTitle: '#fff',
  matchCardSeriesTitle: '#fff',
  matchCardHeaderDivider: '#242d57',
  matchCardContestDetailsBg:
    'transparent radial-gradient(closest-side at 50% 50%, #404F61 0%, #2B3746 100%) 0% 0% no-repeat padding-box',
  matchCardContestDetailsBoxShadow: '0px -2px 23px #020722B3',
  matchCardBorder: '#596779',
  matchCardTeamFlagContainerBg:
    'transparent radial-gradient(closest-side at 50% 50%, #2D353F 0%, #192330 100%) 0% 0% no-repeat padding-box',
  matchCardTeamFlagContainerBoxShadow: '0px 0px 17px #020722B3',
  matchCardActionBtnContainerbg:
    'transparent radial-gradient(closest-side at 50% 50%, #2D353F 0%, #000925 100%) 0% 0% no-repeat padding-box',
  matchCardActionBtnContainerBoxShadow: '0px 0px 17px #020722B3',
  matchCardTimerBg: '#21293C',
  matchCardPlayBtnBg:
    'transparent linear-gradient(180deg, #F6C53F 0%, #FFC300 100%) 0% 0% no-repeat padding-box',
  matchCardPlayBtnBoxShadow: 'inset 0px 2px 15px #F6FF0063',
  matchCardPlayBtnBorder: '#FFF079',
  //for contest list
  contestListSeparator: constants.Colors.DarkBlue,
  contestListItemHeader: constants.Colors.JacksonsPurple1,
  contestListItemHeaderTitle: constants.Colors.White,
  contestListItemHeaderSubTitle: constants.Colors.White,
  contestListCount: constants.Colors.DodgerBlue1,
  contestListCountContainer: constants.Colors.DarkBlue,
  contestListSortingBG: '#040628',
  contestListSortingTitleText: constants.Colors.White,
  contestListSortingIcon: '#fff',
  contestListFabButton: '#f6324b',
  contestListFabButtonText: constants.Colors.White,
  contestListAllContestText: '#fff',
  contestListAllAvailableText: '#fff',
  contestListViewAllText: '#fff',
  contestWinningBreakUpHeaderBg:
    'transparent linear-gradient(99deg, #3A434F 0%, #243343 100%) 0% 0% no-repeat padding-box',
  contestWinningBreakUpHeaderBoxShadow: '3px 0px 12px #000000',
  contestWinningBreakUpRowBg: 'rgb(25, 35, 48,0.6) 0% 0% no-repeat padding-box',
  contestLeaderBoardRowBg: 'rgb(50,65,84,0.6) 0% 0% no-repeat padding-box',
  contestLeaderBoardRowBorder: '#596779',
  //for contest card
  contestCardContainer: '#293648 0% 0% no-repeat padding-box',
  contestCardBoxShadow: '0px 0px 6px #00000029',
  contestCardWinningText: '#FFCE00',
  contestCardEntryFeeText: '#131119',
  contestCardEntryFeeIcon: '#f6324b',
  contestCardItemTitle: constants.Colors.PattensBlue,
  contestCardTeamProgress: '#131119',
  contestCardTeamCurrentProgress: '#F6D03F',
  contestCardEntryFeeWrapper: '#f7c729',
  contestCardEntryFeeWrapperBorder: '#FFF079',
  contestCardBottomItemTextColor: constants.Colors.White,
  contestCardRippleColor: '#0b0e33',
  contestCardProgressStartColor: '#f6324b',
  contestCardProgressEndColor: '#f6324b',
  contestCardTotalWinners: '#fff',
  contestCardUpToBonusDivider: '#212b55',
  contestCardUpToBonus: '#fff',
  contestCardFillTeamSlots: '#fff',
  contestCardTotalSlots: '#fff',
  contestCardWinningPercentageBG: '#fd7575',
  contestCardWinningPercentageText: '#fff',
  contestCardIstWinnerBG: '#40bdff',
  contestCardWinningPercentageTextBG: '#040628',
  contestCardIstWinnerBorder: '#40bdff',
  contestCardIstWinnerTextBG: '#040628',
  contestCardIstWinnerText: '#fff',
  contestCardShareBorder: '#212c56',
  contestCardShareTitleContainer: '#040628',
  contestCardShareIconPrimary: '#040628',
  contestCardShareIconSecondary: '#717fbc',
  contestCardMultiEntryIconPrimary: '#040628',
  contestCardMultiEntryIconSecondary: '#fff',
  contestCardH2HIconPrimary: '#040628',
  contestCardH2HIconSecondary: '#fff',
  contestCardGuaranteedIconPrimary: '#040628',
  contestCardGuaranteedIconSecondary: '#fff',
  contestCardSingleEntryIconPrimary: '#040628',
  contestCardSingleEntryIconSecondary: '#fff',
  contestCardIstWinnerIconPrimary: '#040628',
  contestCardIstWinnerIconSecondary: '#fff',
  contestCardWinningPercentageIconPrimary: '#040628',
  contestCardWinningPercentageIconSecondary: '#fff',
  contestCardLeagueTypeTile: '#fff',
  contestCardLeagueTypeBG: '#494e7e',
  contestCardSLBG: '#D63E3E',
  contestCardSLTitle: '#fff',
  contestCardGLBG: '#7A3CC3',
  contestCardGLTitle: '#fff',
  contestCardWLBG: '#7A3CC3',
  contestCardWLTitle: '#fff',
  contestCardTopSectionBg:
    'transparent radial-gradient(closest-side at 50% 50%, #444E59 0%, #2E3D52 100%) 0% 0% no-repeat padding-box',
  contestCardBorder: '#596779',
  contestCardTopSectionBoxShadow: '0px 0px 17px #020722B3',
  contestTotalPointsBg: '#2D353F 0% 0% no-repeat padding-box',
  contestTotalPointsBoxShadow: 'inset 0px 0px 3px #0000002B, 0px 3px 6px #00000061',
  contestTotalPointsBorder: '#707070',
  ///for contest result card
  contestResultCardContainer: '#0d0f34',
  contestResultCardSeparator: '#596779',
  contestResultCardPrizePool: '#ffce00',
  contestResultCardTitle: '#fff',
  contestResultCardValue: '#fff',
  contestResultViewLeaderBoardText: '#fff',
  contestResultWinningAmountText: constants.Colors.Lime,
  contestResultCardMoneyIcon: '#ffce00',
  contestResultCardHeaderBg:
    'transparent radial-gradient(closest-side at 50% 50%, #3B434D 0%, #27374D 100%) 0% 0% no-repeat padding-box',
  contestResultCardHeaderBoxShadow: '0px 0px 17px #020722B3',
  contestResultCardContentBg: '#222D3B 0% 0% no-repeat padding-box',
  contestResultCardContentBoxShadow: '0px 0px 6px #00000029',
  contestLeaderboardHeaderRowBg:
    'transparent radial-gradient(closest-side at 50% 50%, #404F61 0%, #2B3746 100%) 0% 0% no-repeat padding-box',
  ///for contest share modal
  contestShareModalRawSheet: constants.Colors.RegalBlue,
  contestShareModalContainer: constants.Colors.RegalBlue,
  contestShareModalTitle: constants.Colors.White,
  contestShareModalLinkContainer: constants.Colors.BlueGrey,
  contestShareModalLinkText: constants.Colors.BlueGrey,
  contestShareModalCopyText: constants.Colors.White,

  //for my teams
  myTeamAddTeamBtn: '#f6324b',
  myTeamCreateYourTeamBtn: '#040628',
  myTeamNoTeamText: constants.Colors.WildBlueYonder,
  myTeamCreateTeamBtn: '#f6cf3f',
  myTeamSwitchTeam: '#f6324b',
  myTeamJoinContestDisableBtn: '#37365e',
  myTeamJoinContestDisableBtnText: '#fff',
  myTeamSelectAllBtn: '#ffbe10',
  myTeamsBtnWrapperBg:
    'transparent linear-gradient(127deg, #192027 0%, #19232D 100%) 0% 0% no-repeat padding-box',

  //for team box
  teamBoxContainer: '#0d1134',
  teamBoxSeparator: '#596779',
  teamBoxTeamNumber: '#f6324b',
  teamBoxNotPlayingCount: '#f6324b',
  teamBoxSubstituteBtnBG: '#f6324b',
  teamBoxTitle: '#FFCE00',
  teamBoxCheckIcon: constants.Colors.White,
  teamBoxCheckBackground: '#ffbe10',
  teamBoxCheckedBackground: constants.Colors.Red,
  teamBoxCaptainTitle: '#fff',
  teamBoxViceCaptainTitle: '#fff',
  teamBoxCaptainCircleBG: '#000000',
  teamBoxCaptainCircleText: '#FFCE00',
  teamBoxViceCaptainCircleBG: '#000000',
  teamBoxViceCaptainCircleText: '#FFCE00',
  teamBoxPlayerTypeTitle: '#fff',
  teamBoxPlayerTypeValue: '#fff',
  teamBoxBottomContentBG: '#222D3B 0% 0% no-repeat padding-box',
  teamBoxBottomContentBoxShadow: '0px 0px 6px #00000029',
  teamBoxBottomIcon: '#ffc400',
  teamBoxBtnText: constants.Colors.White,
  teamBoxTopContentBg:
    'transparent radial-gradient(closest-side at 50% 50%, #3B434D 0%, #27374D 100%) 0% 0% no-repeat padding-box',
  teamBoxTopContentBoxShadow: '0px 0px 17px #020722B3',

  //for team preview
  teamPreviewTeamNumber: '#fff',
  teamPreviewScore: '#fff',
  teamPreviewPlayerInfo: '#fff',
  teamPreviewPlayerInfoPoint: '#fff',
  teamPreviewPlayerName: '#fff',
  teamPreviewPlayerRow: '#040628',
  teamPreviewPlaying: '#00df76',
  teamPreviewNotPlaying: '#f6324b',
  teamPreviewCaptainBG: '#f6324b',
  teamPreviewCaptainTitle: '#fff',
  teamPreviewViceCaptainBG: '#f6324b',
  teamPreviewViceCaptainTitle: '#fff',
  teamPreviewRoleIconPrimary: '#fff',
  teamPreviewRoleIconSecondary: '#2F3238',
  teamPreviewPlayerPointsBG: '#040628',
  teamPreviewPlayerPointsText: '#fff',
  teamPreviewDefaultPlayerBtn: '#040628',
  teamPreviewCaptainBtn: '#f6324b',
  teamPreviewCaptainBtnTitle: '#fff',
  teamPreviewViceCaptainBtn: '#b92f4d',
  teamPreviewViceCaptainBtnTitle: '#fff',

  //for create team
  createTeamContinueBtn: '#f6324b',
  createTeamContinueBtnLabel: '#fff',
  createTeamPreviewBtn: '#11171d',
  createTeamPreviewBtnLabel: '#ffc400',
  createTeamBottomBG: '#040628',
  createTeamHeaderMaxTeamMsg: '#fff',
  createTeamTabBarBG: '#040628',
  createTeamTotalPlayerCount: '#fff',
  createTeamTotalPlayerValue: '#fff',
  createTeamDefaultPlayerType: '#11171d',
  createTeamSelectedPlayerType: '#11171d',
  createTeamPlayerTypeTitle: '#fff',
  createTeamHeaderTypeDefaultItem: 'transparent',
  createTeamHeaderTypeActiveItem: 'transparent',
  createTeamHeaderTypeActiveBG: '#f6324b',
  createTeamPlayerTypeDefaultBorder: '#fff',
  createTeamPlayerTypeActiveBorder: '#fff',
  createTeamDisableRow: '#0d0f34',
  createTeamDefaultRow: '#0d0f34',
  createTeamSelectedRow: '#040628',
  createTeamPlayerNameTextDefault: constants.Colors.White,
  createTeamPlayerNameTextDisable: constants.Colors.White,
  createTeamPlayerNameTextSelected: constants.Colors.White,
  createTeamPointTextDefault: constants.Colors.White,
  createTeamPointTextDisable: constants.Colors.White,
  createTeamPointTextSelected: constants.Colors.White,
  createTeamPlayerPlayingBG: 'transparent',
  createTeamPlayerPlayingBorder: '#202b55',
  createTeamPlayerPlaying: constants.Colors.Lime,
  createTeamPlayerIsPlaying: constants.Colors.Lime,
  createTeamPlayerIsNotPlaying: constants.Colors.Red,
  createTeamSelectPlayerBG: '#040628',
  createTeamSelectPlayerTitle: '#fff',
  createTeamDivider: '#202b54',
  createTeamFilterIcon: '#fff',
  createTeamBottomPlayerTypeActiveBG: '#f6324b',
  createTeamBottomPlayerTypeInActiveBG: '#ff6d77',
  createTeamBottomHeaderPlayerCount: '#fff',
  createTeamBottomHeaderPlayerValue: '#fff',
  createTeamBottomHeaderActive: '#f6324b',
  createTeamTabBarDefaultRoleTypeBG: 'linear-gradient(to bottom, #4d6179, #596779)',
  createTeamTabBarDefaultRoleTypeTitle: '#fff',
  createTeamTabBarActiveRoleTypeBG: 'linear-gradient(to bottom, #f6c53f, #ffc300)',
  createTeamTabBarActiveRoleTypeTitle: '#001034',
  createTeamTabBarBorder: '#fff',
  createTeamSelectionBoxbg:
    'transparent radial-gradient(closest-side at 47% 0%, #31445A 0%, #2D3949 100%) 0% 0% no-repeat padding-box',
  createTeamPlayerRowBg:
    'transparent radial-gradient(closest-side at 50% 50%, #404F61 0%, #2B3746 100%) 0% 0% no-repeat padding-box',
  createTeamSelectBtnBg: '#3EBD24',
  createTeamDeselectBtnBg: '#F52C2C',
  createTeamPlayerRowDefaultBorder: '#596779',
  ///for choose captain
  chooseCaptainHeaderContainer: '#040628',
  chooseCaptainHeaderSeparator: '#202a54',
  chooseCaptainHeaderPlayerTypeTitle: '#fff',
  chooseCaptainViceCaptainTitle: '#fff',
  chooseCaptainPlayerRowBG:
    'transparent radial-gradient(closest-side at 50% 50%, #404F61 0%, #2B3746 100%) 0% 0% no-repeat padding-box',

  chooseCaptainPlayerRowName: '#fff',
  chooseCaptainPlayerRowCaptainBG: '#011239',
  chooseCaptainPlayerRowCaptainTitle: '#05ba19',
  chooseCaptainPlayerRowViceCaptainBG: '#011239',
  chooseCaptainPlayerRowViceCaptainTitle: '#05ba19',
  chooseCaptainPlayerRowRoleIcon: '#fff',
  chooseCaptainPlayerRowDefaultPlayerBG: '#040628',
  chooseCaptainPlayerRowDefaultPlayerTitle: '#fff',
  chooseCaptainPlayerRowCaptainPlayerBG: '#f6324b',
  chooseCaptainPlayerRowCaptainPlayerTitle: '#fff',
  chooseCaptainPlayerRowViceCaptainPlayerBG: '#b92f4d',
  chooseCaptainPlayerRowViceCaptainPlayerTitle: '#fff',
  chooseCaptainContinueBtn: '#f6324b',
  chooseCaptainContinueBtnTitle: '#fff',
  chooseCaptainBottomBtnBG: '#040628',

  ///for contest details
  contestDetailsLeaderBoardHeaderBorder: constants.Colors.Greyish,
  contestDetailsUserNameText: '#fff',
  contestDetailsTeamNumber: constants.Colors.White,
  contestDetailsContestScore: 'white',
  contestDetailsWinnerBoardBG: '#0c1034',
  contestDetailsTabHeaderText: '#fff',
  contestDetailsTabDefaultText: '#858999',
  contestDetailsTabActiveText: '#fff',
  contestDetailsTabBorderColor: '#242d57',
  contestDetailsTabUnderlineBG: '#ffd459',
  contestDetailsWinningFooterText: '#fff',
  contestDetailsWinningRowBorder: constants.Colors.JacksonsPurple,
  contestDetailsLeaderBoardHeaderText: '#fff',
  contestDetailsRowMyUser: '#171c43',
  contestDetailsRowOtherUser: 'transparent',
  contestDetailsMyUser: '#f6324b',
  contestDetailsWinningZoneText: constants.Colors.Green,
  contestDetailsContestCard: '#0c1034',
  contestDetailsFooterText: '#fff',

  //For contest confirm modal
  contestConfirmModalContainer: '#222D3B 0% 0% no-repeat padding-box',
  contestConfirmModalSubContainer: '#141c41',
  contestConfirmModalBorder: '#808594',
  contestConfirmModalTitleText: '#fff',
  contestConfirmModalJoinButtonBG:
    'transparent linear-gradient(180deg, #F6D03F 0%, #F8B90C 100%) 0% 0% no-repeat padding-box',
  contestConfirmModalJoinButtonText: '#000',

  //for winning breakup modal
  winningBreakupModalContainer: '#413759',
  winningBreakupModalBorder: '#283058',
  winningBreakupModalVertical: '#040628',
  winningBreakupTotalWinningsText: constants.Colors.PattensBlue,
  winningBreakupModalText: constants.Colors.PattensBlue,
  winningBreakupHeaderTitle: '#fff',
  winningBreakupCloseIconBorder: '#515880',
  winningBreakupCloseIconPrimary: '#fff',
  winningBreakupCloseIconSecondary: '#515880',
  winningBreakupContentBG: '#040628',
  winningBreakupContentTitle: constants.Colors.PattensBlue,
  winningBreakupFooterText: '#fff',
  winningBreakupContentValue: constants.Colors.PattensBlue,

  //for state modal
  stateModalContainer: '#242b54',
  stateModalTitle: constants.Colors.White,
  stateModalCloseBtn: '#f6324b',
  stateModalSubmitBtn: '#f6324b',
  stateModalDropdown: constants.Colors.White,
  stateModalDropdownText: constants.Colors.White,
  stateModalDropdownSelectedItemColor: constants.Colors.Black2,
  stateModalLabel: '#fff',
  stateModalTextInputBG: '#040628',
  stateModalTextInputColor: '#fff',
  stateModalTextInputPlaceHolder: '#555a78',
  stateModalTextInputError: '#f6324b',

  //for team sorting
  teamSortingText: '#000',
  teamSortingIcon: '#000',

  //for player info live
  playerInfoBackground: constants.Colors.newBackground,
  playerInfoHeaderContainer: constants.Colors.newBackground,
  playerInfoPlayerName: constants.Colors.White,
  playerInfoHeaderTitle: constants.Colors.White,
  playerInfoHeaderValue: constants.Colors.White,
  playerInfoContentHeader: constants.Colors.darkNavy,
  playerInfoContentHeaderTitle: constants.Colors.White,
  playerInfoContentHeaderTitlePoint: constants.Colors.White,
  playerInfoContentValue: constants.Colors.newBackground,
  playerInfoContentHeaderValue: constants.Colors.White,
  playerInfoContentHeaderPoint: constants.Colors.White,
  playerInfoContentDivider: constants.Colors.White,
  playerInfoTotalPointsContainer: constants.Colors.newBackground,
  playerInfoTotalPointsTitle: constants.Colors.White,
  playerInfoTotalPointsValue: constants.Colors.White,

  /// for my joined contest
  myJoinedContestNoContestText: '#fff',
  myJoinedContestBtn: '#040628',

  // for contest filter
  contestFilterContainer: '#222D3B 0% 0% no-repeat padding-box',
  contestFilterClearButton: constants.Colors.Red,
  contestFilterApplyButton: constants.Colors.Lime,
  contestFilterButtonText: constants.Colors.White,
  contestFilterItemTitle: constants.Colors.White,
  contestFilterDivider: '#aaa',
  contestFilterSubItemBorder: '#aaa',
  contestFilterSubItemActive: ' #ffc400',
  contestFilterSubItemTitle: constants.Colors.White,
  contestFilterClearBtnBorder: '#FFC400',

  //for mega contest winner
  megaContestContainer: constants.Colors.RegalBlue,
  megaContestWinnerRecentTitle: constants.Colors.White,
  megaContestWinnerMatchCard: constants.Colors.DarkBlue,
  megaContestWinnerMatchTitle: '#fff',
  megaContestWinnerMatchDate: '#fff',
  megaContestWinnerTeamTitle: '#fff',
  megaContestWinnerDivider: constants.Colors.DarkBlue1,
  megaContestWinnerTotalPrize: '#fff',
  megaContestWinnerPrizeCard: constants.Colors.DarkBlue,
  megaContestWinnerPrizeCardBorder: constants.Colors.DarkBlue1,
  megaContestWinnerPrizeCardUserRank: '#fff',
  megaContestWinnerPrizeCardUserName: '#fff',
  megaContestWinnerPrizeCardUserWinning: constants.Colors.DarkBlue1,
  megaContestWinnerPrizeCardUserWinningText: '#fff',
  megaContestWinnerContainer: constants.Colors.RegalBlue,
  megaContestWinnerContainer1: constants.Colors.Sapphire,
  megaContestWinnerContainer2: constants.Colors.DarkBlue,

  //for tips screen
  tipsBackground: constants.Colors.RegalBlue,

  //for fixtures match item
  fixtureMatchItemBG: '#050729',
  fixtureMatchHeaderBG: '#505381',
  fixtureMatchHeaderTitle: '#fff',
  fixtureMatchItemRipple: '#06082a',
  fixtureMatchItemBorder: '#06082a',
  fixtureMatchItemTeamName: '#fff',
  fixtureMatchItemTimeOut: 'transparent',
  fixtureMatchItemTimeOutText: '#fff',
  fixtureMatchItemRibbon: '#1b1f3f',
  fixtureMatchSeriesTitle: '#005089',
  fixtureMatchFooterBG: '#505381',
  fixtureMatchLineupOutBG: '#48bf6a',
  fixtureMatchLineupOutTitle: constants.Colors.White,
  fixtureMatchShortTitle: '#fff',
  fixtureMatchItemMakeTeamContainer: '#005089',
  fixtureMatchItemMakeTeamText: '#fff',

  //for match tab
  matchTabIndicator: '#040628',
  matchTabBG: '#040628',
  matchTabActive: '#fff',
  matchTabInActive: '#8993a8',
  matchTabRefresh: '#fff',

  //for gadget league
  leagueTitle: '#fff',

  //for home tab
  homeTabActiveBG: '#21294f',
  homeTabInActiveBG: '#4c517b',
  homeTabBorderLeftColor: '#8993a8',
  homeTabActiveTitle: '#fff',
  homeTabInActiveTitle: '#001a31',
  homeTabDivider: '#21294f',

  //for grand league
  GLLeaderBoardTabActiveTitle: '#fff',
  GLLeaderBoardTabInActiveTitle: '#fff',
  GLLeaderBoardTabActiveBorder: '#788fa3',
  GLLeaderBoardSubTabBG: '#040628',
  GLLeaderBoardSubTabActiveTitle: '#fff',
  GLLeaderBoardSubTabInActiveTitle: '#fff',
  GLLeaderBoardHeaderTitle: '#fff',
  GLLeaderBoardHeaderBoxBG: 'transparent',
  GLLeaderBoardItemTitle: '#fff',
  GLLeaderBoardItemBoxBG: 'transparent',
  GLLeaderBoardWinningHeaderTitle: '#fff',
  GLLeaderBoardWinningHeaderBoxBG: 'transparent',
  GLLeaderBoardWinningItemTitle: '#fff',
  GLLeaderBoardWinningItemBoxBG: '#040628',
  GLLeaderBoardPreviousWinnersBG: '#040628',
  GLLeaderBoardPreviousWinnersText: '#fff',

  // for fantasy my question ans
  myQueAnsTabButtonBG: '#040628',
  myQueAnsActiveTabText: '#fff',
  myQueAnsInActiveTabText: '#788fa3',
  myQueAnsCurrentStep: '#fff',
  myQueAnsTotalStep: '#fff',
  myQueAnsStepFilledBG: '#040628',
  myQueAnsStepUnFilledBG: '#040628',
  myQueAnsStepAccomplishBG: '#040628',
  myQueAns2xText: '#fff',

  // for preview answer
  previewAnswerUserName: '#fff',

  // for insight info
  insightInfoBG: '#fff',
  insightInfoHeaderTitle: '#1a1f3f',
  insightInfoContentTitle: '#1a1f3f',
  insightInfoCloseBtn: '#1a1f3f',
  insightInfoBorder: '#FFC400',

  //matchTab
  matchTabActivebg:
    'transparent linear-gradient(180deg, #F6D03F 0%, #F8B90C 100%) 0% 0% no-repeat padding-box',
  matchTabDefaultBg:
    'transparent linear-gradient(180deg, #596779 0%, #2D353F 100%) 0% 0% no-repeat padding-box',
  //yesnoAnswerCard
  yesNoAnswerCardImgBg:
    'transparent radial-gradient(closest-side at 50% 50%, #171B20 0%, #101823 100%) 0% 0% no-repeat padding-box',
  doubelUpContainerBg:
    'transparent radial-gradient(closest-side at 50% 50%, #314052 0%, #212C3A 100%) 0% 0% no-repeat padding-box',
  yesNoInsightModalBg: '#11171D 0% 0% no-repeat padding-box'
};
